export {};
//# sourceMappingURL=ExpoUpdatesModule.types.js.map